module.exports = __webpack_public_path__ + "img/text3.8ee96a87.svg";